export default __webpack_public_path__ + "static/media/role.1e694471.mp3";